import React, { Component } from 'react'
import CardSection from '../components/CardSection'
import { Button, Text } from 'components/base'

export default class UpdateDetailsModal extends Component {
  state = {
    cardholderName: '',
    card: {},
    token: null,

    checking: false,
    error: null,
  }

  render() {
    return (
      <div>
        <Text.Subtitle>Payment details</Text.Subtitle>
        <div className="font-size-small shade-20 padding-vertical-large">
          Set your new payment method information
        </div>
        <CardSection
          onCardholderNameChange={this.onCardholderNameChange}
          onCardChange={this.onCardChange}
        />
        <div className="flexbox flexbox-space-between width-full margin-top-medium">
          <Button.Secondary onClick={this.props.onCancel}>
            Cancel
          </Button.Secondary>
          <Button.Primary disabled={!this.state.token} onClick={this.onSave}>
            {this.getSaveButtonText()}
          </Button.Primary>
        </div>
      </div>
    )
  }

  onCardholderNameChange = cardholderName => {
    this.setState({
      cardholderName,
    })
  }

  onCardChange = (stripe, card) => {
    this.setState({ card })

    this.props.onCardChange(card)

    if (card.complete) {
      this.setState({ checking: true })
      stripe
        .createToken({
          name: this.state.cardholderName,
          address_line1: this.props.paymentInfos.addressLine1,
          address_line2: this.props.paymentInfos.addressLine2,
          address_city: this.props.paymentInfos.addressCity,
          address_state: this.props.paymentInfos.addressState,
          address_zip: this.props.paymentInfos.addressPostalCode,
          address_country: this.props.paymentInfos.addressCountry,
        })
        .then(
          payload => {
            if (payload.error) {
              this.setState({
                checking: false,
                error: payload.error,
                token: null,
              })
            } else {
              this.setState({
                checking: false,
                token: payload.token.id,
                error: null,
              })
            }
          },
          error => {
            this.setState({
              checking: false,
              error,
              token: null,
            })
          }
        )
    }
  }

  onSave = () => {
    this.props.onSave(this.state.token)
  }

  getSaveButtonText() {
    if (this.state.checking) {
      return 'Checking...'
    }
    if (this.props.loading) {
      return 'Saving...'
    }
    if (this.state.error) {
      return this.state.error.message
    }
    if (this.props.error) {
      return this.props.error.message
    }
    return 'Save'
  }
}
